module.exports = __webpack_public_path__ + "img/arj.a617b198.png";